var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "w-12 h-12 text-indigo-600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 10.37A6 6 0 1 1 10.34 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6h1v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.71 13.88.7.71-2.82 2.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReqs);
export default __webpack_public_path__ + "static/media/icon-reqs.0a9ba7c943f7a725d7d349ea95e07b55.svg";
export { ForwardRef as ReactComponent };